import * as React from 'react';
export const SelectPositionerContext = /*#__PURE__*/React.createContext(null);
export function useSelectPositionerContext() {
  const context = React.useContext(SelectPositionerContext);
  if (context === null) {
    throw new Error('Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>.');
  }
  return context;
}